import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Button } from "react-bootstrap";
import { Font } from "ckeditor5";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import Swal from "sweetalert2";
import { expr } from "jquery";

export default function PhieuNhapKhoKCS({ item, icons, icon, data }) {
  const { lang, proxy, functions } = useSelector((state) => state);
  const [listImages, setListImages] = useState([]);
  const param = data?.["2SPN"];

  const [showModal, setShowModal] = useState(false);

  const handleModalShow = () => setShowModal(true);
  const handleModalClose = () => setShowModal(false);
  const {
    isExcelDocumentFormat,
    isPdfDocumentFormat,
    isDocDocumentFormat,
    isZipDocumentFormat,
  } = functions;

  useEffect(() => {
    if (showModal) {
      const fetchData = async () => {
        if (param?.length > 0) {
          const response = await fetch(
            `${proxy()}/api/PNK/ChungTuKCS?phieuNhapKho=${param}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem("_token"),
              },
            }
          );
          const { data } = await response.json();

          if (data && data?.length > 0) {
            setListImages(data);
          } else {
            setListImages([]);
          }
        }
      };
      fetchData();
    }
  }, [param, showModal]);

  const handleDownload = async (url, newFileName) => {
    try {
      const response = await fetch(`${proxy()}/download${url}`);

      if (!response.ok) {
        throw new Error("File not found");
      }

      const blob = await response.blob();
      const fileUrl = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = fileUrl;
      a.download = newFileName;
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(fileUrl);
    } catch (error) {
      await Swal.fire({
        title: lang?.["error"],
        text: "Không tìm thấy file",
        icon: "error",
        showConfirmButton: true,
      });
      console.error("Error downloading file:", error);
    }
  };
  // console.log("listImages", listImages);
  return (
    <>
      <div>
        <FontAwesomeIcon
          icon={icons[icon]?.icon}
          title={item?.title ? item?.title : lang["redirect_button"]}
          onClick={handleModalShow}
        />
      </div>

      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header>
          <Modal.Title>
            {/* Chứng từ KCS */}
            {item?.title ? item?.title : lang["redirect_button"]}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              overflow: "auto",
              height: "50vh",
            }}
          >
            <table className="table table-custom">
              <thead>
                <tr
                  style={{
                    position: "sticky",
                    top: "-1px",
                  }}
                >
                  <td>#</td>
                  <td>Tên file</td>
                  <td className="align-center">File</td>
                  <td className="align-center">Thao tác</td>
                </tr>
              </thead>
              <tbody>
                {listImages.length > 0 ? (
                  listImages?.map((item, index) => {
                    let content;
                    let isImage = false;
                    const { url, name } = item;

                    if (isExcelDocumentFormat(url)) {
                      content = (
                        <img
                          src={"/images/icon/excel.svg"}
                          className="selected-image-add"
                          alt="#"
                        />
                      );
                    } else if (isPdfDocumentFormat(url)) {
                      content = (
                        <img
                          src={"/images/icon/pdf.svg"}
                          className="selected-image-add"
                          alt="#"
                        />
                      );
                    } else if (isDocDocumentFormat(url)) {
                      content = (
                        <img
                          src={"/images/icon/docs.svg"}
                          className="selected-image-add"
                          alt="#"
                        />
                      );
                    } else if (isZipDocumentFormat(url)) {
                      content = (
                        <img
                          src={"/images/icon/zip.svg"}
                          className="selected-image-add"
                          alt="#"
                        />
                      );
                    } else {
                      // isImage = true;
                      content = (
                        <img
                          src={proxy() + url}
                          className="selected-image-add"
                          alt="#"
                          width={200}
                          onError={(e) => {
                            if (e.target.src !== proxy + url) {
                              e.target.src = "/images/icon/file-unknown.svg";
                            }
                          }}
                        />
                      );
                    }
                    return (
                      <tr key={index}>
                        <td width={1}>{index + 1}</td>
                        <td>{item?.name}</td>
                        <td width={1} className="align-center">
                          {content}
                        </td>
                        <td
                          width={1}
                          className="pointer align-center"
                          onClick={() => !isImage && handleDownload(url, name)}
                        >
                          <FontAwesomeIcon
                            icon={faDownload}
                            color="green"
                            fontSize="24"
                          />
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={6} className="align-center">
                      {lang["not found"]}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            {lang["btn.close"]}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
